export default __webpack_public_path__ + "static/media/up_to_us_logo.fbe1c0e1.svg";